module.exports = __webpack_public_path__ + "img/badge-volume.6befbcd9.svg";